import { useEffect } from 'react'
import { calNotes } from '../reserveReducer'
import { openCalBooking, resetCalBooking } from '../../../hooks/useCalEmbed'
import StepShell, { Question } from '../StepShell'

export default function StepDone({ answers, active, reportedBurn }) {
  useEffect(() => {
    if (!active) return
    const prefillConfig = {
      layout: 'month_view',
      useSlotsViewOnSmallScreen: 'true',
      name: answers.name || '',
      email: answers.email || '',
      notes: calNotes(answers, reportedBurn),
    }
    openCalBooking(prefillConfig)
    return () => resetCalBooking()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active])

  return (
    <StepShell active={active} step={6}>
      <div className="pt-3.5 pb-0.5 text-center">
        <div className="mx-auto mb-[18px] flex h-14 w-14 items-center justify-center rounded-full bg-[rgba(15,122,77,.1)] text-2xl text-[var(--live)]">&#10003;</div>
        <div className="font-mono text-[11.5px] tracking-[0.09em] text-[var(--ink-blue)] uppercase">Reservation logged</div>
        <Question>Let's put a date on it.</Question>
        <p className="mt-2.5 text-[0.98rem] leading-[1.6] text-[var(--muted)]">
          Your configuration just landed in our queue. Grab 15 minutes below and we'll turn it into a signed order with a delivery date &mdash; live, not over email.
        </p>
      </div>
      {/* min-h (not a fixed h) so the wrapper grows with Cal's auto-resizing
          iframe — a fixed height clipped the taller confirmation view and made
          the modal impossible to scroll to the bottom. The modal's own
          overflow-y-auto then scrolls the whole thing. */}
      <div id="cal-booking" className="mt-[22px] min-h-[600px] w-full overflow-hidden rounded-[14px] border border-[var(--line)] [@media(max-width:640px)]:min-h-[640px]" />
    </StepShell>
  )
}
